import React, { useEffect } from "react";
import styled from "styled-components";
import Home from "./screen/Home";
import { HomeProvider } from "./screen/Home/HomeContext.js";
import Navigator from "./components/Navigator";
import Footer from "./components/Footer";
import BoardPage from "./screen/Board/BoardPage";
import HelpBoardPage from "./screen/HelpBoard/HelpBoardPage";
import { Routes, Route } from "react-router-dom";
import { BoardList } from "./screen/Board/BoardList";
import { HelpBoardList } from "./screen/HelpBoard/HelpBoardList/index.js";
import { RegisterForm, Login } from "./components/Login";
import { AuthProvider } from "./context/AuthContext";
import Mypage from "./components/MyPage/index.js";
import { useAuth } from "./context/AuthContext";

const AppContainer = styled.div`
  background-color: #222;
  height: 100%;
  color: white;
`;

const Container = styled.div`
  max-width: 1500px;
  background-color: #222;
  margin: 0 auto;
  min-height: 100vh;
`;

const Header = styled.header`
  padding: 20px;
  color: white;

  @media (max-width: 768px) {
    padding: 10px;
    text-align: center;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    padding: 15px;
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    padding: 15px;
  }
`;

const FooterContainer = styled.footer`
  padding: 20px;
  color: white;
  margin-top: auto;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    padding: 15px;
  }
`;

function App() {
  const { login } = useAuth();

  useEffect(() => {
    const fetchSessionData = async () => {
      try {
        const response = await fetch('/api/session');
        if (response.ok) {
          const userData = await response.json();
          login(userData);
        }
      } catch (error) {
        console.error('Error fetching session data:', error);
      }
    };

    fetchSessionData();
  }, [login]);

  return (
    <AuthProvider>
      <AppContainer>
        <Container>
          <Header>
            <Navigator />
          </Header>
          <Content>
            <Routes>
              <Route
                path="/"
                element={
                  <HomeProvider>
                    <Home />
                  </HomeProvider>
                }
                key="Home"
              />
              <Route path="/BoardPage" element={<BoardPage />} />
              <Route path="/board" element={<BoardList />} />
              <Route path="/HelpBoardPage" element={<HelpBoardPage />} />
              <Route path="/HelpBoard" element={<HelpBoardList />} />
              <Route path="/Login" element={<Login />} />
              <Route path="/Register" element={<RegisterForm />} />
              <Route path="/Mypage" element={<Mypage />} />
            </Routes>
          </Content>
          <FooterContainer>
            <Footer />
          </FooterContainer>
        </Container>
      </AppContainer>
    </AuthProvider>
  );
}

export default App;
